/**
 * Whether a participant may press their own microphone or camera button.
 *
 * The host's Microphone / Video switches are room-wide. A host can still let
 * one person through with Request Audio / Request Video: accepting it gives
 * that person their own device back (`granted`) until the host mutes them
 * individually or changes the room switch again.
 *
 * Turning a device OFF is never blocked. Accepting a request used to unmute
 * the person past the switch while the button stayed disabled, so they were
 * live and could not mute themselves; every click said the host had disabled
 * the microphone.
 */
export function canPressDevice(input: {
  /** Joined through the view-only link: no devices at all. */
  viewOnly: boolean
  /** Hosts and co-hosts are not bound by the room switches. */
  isModerator: boolean
  /** The room switch for this device is on. */
  roomAllows: boolean
  /** The host asked this person to turn the device on, and they accepted. */
  granted: boolean
  /** The device is currently on. */
  isOn: boolean
}): boolean {
  if (input.viewOnly) return false
  return input.isOn || input.isModerator || input.roomAllows || input.granted
}
